// The exact D2 wording for the student payment permission step
// (student-self-signup-prd.md §19). Kept out of the component file so that file
// exports only its component (react-refresh/only-export-components).

export const CARD_HOLDER_PERMISSION_TEXT =
  'I’m allowed to use this payment card — it is mine or the card holder has said yes';

export const GUARDIAN_PURCHASE_PERMISSION_TEXT =
  'I have permission from a parent or guardian to buy things on Airbotix';
